'use strict';

wbApp.controller('UserRolesCtrl', ['$scope', '$modal', '$translate', 'userRolesSvc',
function ($scope, $modal, $translate, userRolesSvc) {

    $scope.$on('refreshData', function (e, data) {
        $scope.userRoles = userRolesSvc.getAllAsync(true);
    });

    $scope.gridSettings = {
        name: 'userRoles',
        columns: [
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', width: '180px' },
            { dataField: 'description', caption: $translate.instant('TXT_LBL_DESCRIPTION'), dataType: 'string' },
            { dataField: 'buildIn', caption: $translate.instant('TXT_LBL_SYSTEM'), dataType: 'boolean', width: '70px' }
        ]
    };

    $scope.userRoles = userRolesSvc.getAllAsync();

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = userRolesSvc.createNew();
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        userRolesSvc.remove(data);
    }

    var detailDialogPromise = $modal({
        templateUrl: 'users/user-roles-detail.html',
        show: false,
        scope: $scope
    });

}]);
